import { FunctionComponent, useEffect, useState } from "react"
import { deleteFaq, editFaq, Faq, FaqApiPayload, fetchFaq, fetchFaqs, filterAndSort, findOrderNumber, increaseOrderInList, reduceOrderInList, selectAllGeneralFaqs } from "../faqSlice"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { useAuth } from "react-oidc-context"
import { isFulfilled } from "@reduxjs/toolkit"
import { useNavigate } from "react-router"
import { ExpanderBar } from "../../shared/components/widgets/ExpanderBar"

import styled from 'styled-components'


export const Wrapper = styled.article`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 0.5rem;
  margin-bottom: 1rem;

  .expander-container {
    float: left;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .question-controls {
    float: right;
  }

`
type FaqCardParams = {
  key: string
  faq: Faq,
}

export const FaqCard: FunctionComponent<FaqCardParams> = ({faq}) => {
  console.log(faq)
  const dispatch = useAppDispatch();
  const faqstate = useAppSelector(state => state.faqstate);
  

  const [faqs, setFaqs] = useState([] as Faq[])

  useEffect( () => {
    // in case faqs have not been initialised  
    setFaqs(filterAndSort(faqstate.faqs,'general'));

    // tracking whats going on
    console.log(faqs)

  }, [faqstate.faqs])
  
  const auth = useAuth();
  const navigate = useNavigate();
  console.log(auth.isAuthenticated)

  const handleSwap = async(up: Faq, down: Faq) => {
    console.log('up')
    console.log(up)
    console.log('down')
    console.log(down)
    const at: string = auth.user?.access_token as string;
    const action1 = await dispatch(editFaq({accessToken: at, id: up.id, faq: up}));
    const action2 = await dispatch(editFaq({accessToken: at, id: down.id, faq: down}));
    if (isFulfilled(action1) && isFulfilled(action2)) {
      dispatch(fetchFaqs());
    }
  }

  const handleUp = async () => {
    const actionFaqOrder = findOrderNumber(faqs, faq.id, 'general');
    if (actionFaqOrder !== 0) {
      const upDn = reduceOrderInList(faqs, faq, 'general')
      handleSwap(upDn.lower,upDn.rise);
    }
  }

  const handleDown = async () => {
    const actionFaqOrder = findOrderNumber(faqs, faq.id, 'general');
    if (actionFaqOrder !== faqs.length - 1) {
      const upDn = increaseOrderInList(faqs, faq, 'general')
      handleSwap(upDn.lower,upDn.rise);
    }
  }

  const handleEdit = async () => {
    // use returned value to ensure that dispatch finishes
    const action = await dispatch(fetchFaq({id: faq.id} as FaqApiPayload))
    if (isFulfilled(action)) {
      navigate(`/faq-edit/${faq.id}`)
    }
  }
  const handleDelete = async () => {
    const actionFaqOrder = findOrderNumber(faqs, faq.id, 'general');
    const orderUpdates = faqs
      .filter(f => f.faqOrder > actionFaqOrder)
      .map(f => {
        const updated = { ...f, faqOrder: f.faqOrder - 1 };
        const payload: FaqApiPayload = { accessToken: auth.user?.access_token as string, id: f.id, faq: updated }
        return dispatch(editFaq(payload));
      });
    await Promise.all(orderUpdates);

    const action = await dispatch(deleteFaq({accessToken: auth.user?.access_token as string, id: faq.id} as FaqApiPayload))
    if (isFulfilled(action)) {
      navigate('/faqs');
    }
  }

  return (
    <Wrapper>
        <div className="expander-container">

          <ExpanderBar heading={faq.question} content={faq.answer}/>

          <div className="question-controls">

          { auth.isAuthenticated && (
            <div className="right-align-container">
              <button
                type='button'
                className='btn'
                onClick={() => handleUp()}
              >
                Up
              </button>
              <button
                type='button'
                className='btn'
                onClick={() => handleDown()}
              >
                Down
              </button>
              <button
                type='button'
                className='btn'
                onClick={() => handleEdit()}
              >
                Edit
              </button>
              <button
                type='button'
                className='btn btn-danger'
                onClick={() => handleDelete()}
              >
                Delete
              </button>
            </div>
          )}
          </div>

        </div>

    </Wrapper>
  )
}